import {get, post} from '../requestUtils'

export function getProjects() {
  return get('/project/projects')
}

export function newProject(name) {
  return post('/project/new', {name})
}

export function updateProjectLineCredential(projectId, cred) {
  return post(`/project/${projectId}/line`, cred)
}

export function uploadChatImage(projectId, customerId, file) {
  const fd = new FormData()
  fd.append('file', file, file.name)
  return post(
    `/project/${projectId}/customers/${customerId}/upload/chat/image`,
    fd,
    {
      'Content-Type': 'multipart/form-data',
    },
  )
}

export function uploadFile(projectId, file) {
  const fd = new FormData()
  fd.append('file', file, file.name)
  return post(`/project/${projectId}/upload`, fd, {
    'Content-Type': 'multipart/form-data',
  })
}

export function getLineCredential(projectId) {
  return get(`/project/${projectId}/line`)
}

export function getUsersInProject(projectId) {
  return get(`/project/${projectId}/members`)
}

export function inviteUser(projectId, email, role) {
  return post(`/project/${projectId}/invite`, {email, role})
}



// WEBPACK FOOTER //
// ./src/functions/project/index.js